import React, { useEffect, useState } from "react";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { overallRatings, rateContest } from "../../../redux/contest/action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getRating } from "../../../redux/categary/action";
import ProfileImageWithFallback from "../../../common/ProfileImageWithFallback";

export default function ModelGiveReview({ setReview, proposalmilestones, posts, type = 2 }) {
  const [loading, setLoading] = useState(false);
  const [overallRating, setOverallRating] = useState(0); // Average rating state
  const [comment, setComment] = useState(''); // Average rating state
  const [categoryRatings, setCategoryRatings] = useState({}); // To hold category ratings
  const path = "Assets/scss/postproject.module.scss";
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const ratinglist = useSelector(({ categary: { ratinglist } }) => ratinglist);

  useEffect(() => {
    dispatch(getRating());
  }, [dispatch]);

  const handleCategoryRating = (categoryId, rating) => {
    setCategoryRatings((prevRatings) => ({
      ...prevRatings,
      [categoryId]: rating,
    }));
  };

  const submitReview = () => {
    if (overallRating == 0) {
      alert("Please select an Average rating before submitting!");
      return;
    }

    const ratingData = {
      post_id: posts?.id,
      proposal_id: proposalmilestones?.id,
      type: type,
      user_id: posts?.is_mine == 1 ? proposalmilestones?.user_id : posts?.user_id,
      rating: overallRating,
      comment: comment,
      rating_category: Object.keys(categoryRatings).map((categoryId) => ({
        id: categoryId,
        rating: categoryRatings[categoryId],
      })),
      ...(type == 5 && {
        'rental_request_id': type == 5 ? posts?.id : '',
      }),
    };


    dispatch(overallRatings(ratingData, setLoading));
    setReview(false)
  };
  console.log(posts, 'JSON.stringify(posts)');

  return (
    <div className="rent-product">
      <div className="modal-head">
        <h6>Please Review </h6>
        <button onClick={() => setReview((state) => !state)} className="btn">
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/x-circle.svg`}
            alt=""
          />
        </button>
      </div>
      <div >
        <div className="feedback-sec">
          {
            posts?.is_mine == 1 ?
              <ProfileImageWithFallback url={proposalmilestones?.profile_image} /> :
              <ProfileImageWithFallback url={posts?.user?.profile_image} />
          }
          <h6>Your feedback matters</h6>
          <p>
            Please provide your rating and feedback for your recent experience with
            <b>
              {' '} {
                posts?.is_mine == 1 ? <>{proposalmilestones?.first_name} {proposalmilestones?.last_name}</> : <>{posts?.user?.first_name} {posts?.user?.last_name}</>
              }

            </b>
          </p>
        </div>
        <div className="overall-rating">
          {/* Average rating */}
          <div className="earn-head">
            <h2>Average rating</h2>
            <div className="star">
              <p>
                {[1, 2, 3, 4, 5].map((star) => (
                  <i
                    style={{ color: `${star <= overallRating ? "#08AF22" : "#ccc"}` }}
                    key={star}
                    className={`fa-solid fa-star ${star <= overallRating ? "active" : ""}`}
                    aria-hidden="true"
                    onClick={() => setOverallRating(star)} // Set Average rating
                  ></i>
                ))}
              </p>
              <div className="form-group">
                <label htmlFor="message">Message </label>

                <textarea
                  className="form-control"
                  rows="5"
                  style={{ width: "100%" }}
                  id="message"
                  name="message"
                  placeholder="Enter Your message"
                  onChange={(e) => setComment(e.target.value)}
                />

              </div>
            </div>
          </div>




          {/* Category Ratings */}
          {ratinglist && ratinglist.length > 0 && (
            <div className="review-right">
              <h2>Category Ratings</h2>
              {ratinglist.map((item) => (
                <div key={item.id} className="review-star">
                  <p>{item?.title}</p>
                  <div className="star-sec">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i
                        style={{ color: `${star <= (categoryRatings[item.id] || 0) ? "#FFC21B" : "#ccc"}` }}
                        key={star}
                        className={`fa-solid fa-star ${star <= (categoryRatings[item.id] || 0) ? "active" : ""}`}
                        aria-hidden="true"
                        onClick={() => handleCategoryRating(item.id, star)} // Handle category rating
                      ></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Submit the review */}
        </div>
        <button className="buttons background-button mx-auto" onClick={submitReview}>Submit Overall and Category Ratings</button>
      </div>
    </div>
  );
}
